import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $registerButton: this.el._$('.masthead__register-btn'),
      $signInButton: this.el._$('.masthead__sign-in-btn')
    }
  }

  addListeners() {
    this.dom.$registerButton._on('click', this.handleRegisterClick.bind(this));
    this.dom.$signInButton._on('click', this.handleSignInClick.bind(this));
  }

  handleRegisterClick(e) {
    e.preventDefault();

    const header = document._$('.header');
    const registerEvent = new CustomEvent('register');

    header.dispatchEvent(registerEvent);
  }

  handleSignInClick(e) {
    if (!e.target.href) {
      e.preventDefault();
      this.handleRegisterClick(e);
    }
  }
}

export default Module;
